<template>
    <div>
        <Dialog v-model:visible="visible" :style="{ width: '50vw' }" :breakpoints="{ '960px': '75vw', '641px': '100vw' }" :header="assessmentStructure.header" maximizable modal class="p-fluid dialog-header" @hide="$emit('hide-dialog', true)">
            <div class="text-center">
                <h5>{{ assessmentStructure.message }}</h5>
            </div>
            <div class="card overflow-x-auto">
                <OrganizationChart :value="orgData" :collapsible="true">
                    <template #default="slotProps">
                        <div class="flex flex-column">
                            <div class="flex flex-column align-items-center">
                                <span class="font-bold mb-2">{{ slotProps.node.stepLabel }}</span>
                                <!-- <span>{{ slotProps.node. }}</span> -->
                            </div>
                        </div>
                    </template>
                </OrganizationChart>
            </div>
        </Dialog>
    </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { ref, inject, computed } from 'vue';

const stepStore = inject('stepStore');
const { steps } = storeToRefs(stepStore);
const assessmentStore = inject('assessmentStore');
const { assessmentStructure } = storeToRefs(assessmentStore);

const visible = ref(true);

const orgData = computed(() => {
    const data = assessmentStructure.value?.data;
    // Initiate the parent structure
    let structure = {
        key: data?.stepId,
        stepLabel: getStepLabelById(data?.stepId),
        blockId: data?.blockId,
        blockCode: data?.blockCode,
        entry: data?.entry,
        children: [],
        styleClass: 'bg-indigo-500 text-white border-round-xl',
    };
    // now loop through the children and make the structure same
    structure.children = data?.children?.length > 0 ? formatInnerElements(data?.children) : [];

    // console.log(structure);
    return structure;
});

const formatInnerElements = (data) => {
    let children = [];
    for (let obj of data) {
        let item = obj.to;
        // debugger;
        let nodeData = {
            key: item?.stepId,
            stepLabel: getStepLabelById(item?.stepId),
            blockId: item?.blockId,
            blockCode: item?.blockCode,
            entry: item?.entry,
            children: item?.children?.length > 0 ? formatInnerElements(item?.children) : [],
            styleClass: 'bg-indigo-500 text-white border-round-xl',
        };
        children.push(nodeData);
    }
    return children;
};

const getStepLabelById = (stepId) => {
    return steps.value.find((step) => step.id === stepId)?.label;
};
</script>
